'use client';

import { BasicModal, BasicLabel, BasicTextField, TextButton, BasicSelect } from 'components';
import { useAlert } from 'contexts';
import { useChangePasswordForce, useForgotPassword } from 'domains/Auth';
import { useFetchNations } from 'domains/Setting';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { cookieStorage } from 'services';
import { Column, Row } from 'styles';

interface ForgotPasswordProps {
  open: boolean;
  onClose: () => void;
}

export const ForgotPassword: React.FC<ForgotPasswordProps> = ({ open, onClose }) => {
  const [forgotPasswordRequest, setForgotPasswordRequest] = useState({
    nationId: '5b393101-42b1-437f-a9d8-379430a7cf79',
    mobile: ''
  });
  const { mutateAsync: forgotPassword } = useForgotPassword();
  const { showAlert } = useAlert();

  const { data: nations } = useFetchNations({ data: { mobile: true } });

  return (
    <BasicModal
      open={open}
      width={460}
      height={375}
      onClose={onClose}
      header="I Don`t know my Password"
      body={
        <Column gap="30px">
          <Column gap="20px">
            <div>Enter the Information Associated with Your Account.</div>

            <Column>
              <BasicLabel label={'Country'} required style={{ width: '200px' }} />
              <BasicSelect
                fullWidth
                value={forgotPasswordRequest.nationId}
                onChange={(e) =>
                  setForgotPasswordRequest((prev) => ({
                    ...prev,
                    nationId: e.target.value as string
                  }))
                }
                options={(nations || []).map((nation) => ({
                  label: (
                    <Row style={{ alignItems: 'center' }}>
                      <img style={{ width: '20px', height: '20px' }} src={nation.flagUri} />
                      <Row gap="0px">
                        <div>{nation.countryCode}</div>
                        <div>{nation.numberCode}</div>
                      </Row>
                    </Row>
                  ),
                  value: nation.nationId
                }))}
              />
            </Column>

            <Column>
              <BasicLabel label={'Mobile Number'} required style={{ width: '200px' }} />
              <BasicTextField
                fullWidth
                placeholder="Mobile"
                value={forgotPasswordRequest.mobile}
                onChange={(e) =>
                  setForgotPasswordRequest((prev) => ({
                    ...prev,
                    mobile: e.target.value as string
                  }))
                }
              />
            </Column>
          </Column>

          <Row style={{ justifyContent: 'end', gap: '10px' }}>
            <TextButton label={'Cancel'} variant="outlined" onClick={onClose} />
            <TextButton
              label={'Confirm'}
              onClick={() => {
                if (!forgotPasswordRequest.mobile) {
                  console.log('Mobile number is required.');
                  showAlert('Mobile number is required.');
                  return;
                }

                forgotPassword(
                  { data: forgotPasswordRequest },
                  {
                    onSuccess: () => {
                      showAlert('Temporary password has been sent issued.', () => {
                        onClose();
                      });
                    },
                    onError: (error) => {
                      showAlert(
                        `There is no registered information. Please check the phone number you entered or contact the on-site manager.`
                      );
                    }
                  }
                );
              }}
            />
          </Row>
        </Column>
      }
    />
  );
};
